import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/comics';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20beautiful%20artistic%20Korean%20webtoon-inspired%20illustration%20with%20soft%20warm%20gradients%20of%20coral%20pink%20and%20cream%2C%20delicate%20floating%20petals%20and%20ink%20brush%20strokes%2C%20dreamy%20atmospheric%20lighting%2C%20elegant%20book%20pages%20drifting%20gently%2C%20abstract%20oriental%20ink%20wash%20painting%20style%20with%20modern%20minimalist%20touch%2C%20warm%20golden%20light%20accents&width=1920&height=1080&seq=hero-bg-hanman&orientation=landscape"
          alt="韩漫网 - 好看的韩国漫画在线阅读"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 tracking-wide">
          发现你的下一部<span className="text-primary-300">心头好</span>
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-xl mb-8 leading-relaxed">
          {siteInfo.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/romance"
            className="whitespace-nowrap px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-compass-3-line mr-2"></i>探索漫画
          </Link>
          <Link
            to="/category/fantasy"
            className="whitespace-nowrap px-8 py-3 rounded-full bg-white/15 text-white backdrop-blur-sm font-medium text-sm hover:bg-white/25 transition-colors cursor-pointer border border-white/20"
          >
            <i className="ri-fire-line mr-2"></i>热门推荐
          </Link>
        </div>
        <div className="mt-10 flex items-center gap-6 text-white/60 text-sm">
          <div className="flex items-center gap-1">
            <i className="ri-bookmark-line"></i>
            <span>2000+ 漫画作品</span>
          </div>
          <div className="w-1 h-1 rounded-full bg-white/40"></div>
          <div className="flex items-center gap-1">
            <i className="ri-user-heart-line"></i>
            <span>每日更新</span>
          </div>
          <div className="w-1 h-1 rounded-full bg-white/40"></div>
          <div className="flex items-center gap-1">
            <i className="ri-shield-check-line"></i>
            <span>高清正版</span>
          </div>
        </div>
      </div>
    </section>
  );
}